import React from "react";
import { useSelector } from "react-redux";
import { IRootState } from "../../reducer/CombineReducer";
import { Numbers } from "../../common/constants/Number";
import { INotification } from "./redux/Types";
import { Notification } from "./Notification.logic";
import "./Styles.scss";

interface INotificationProp {
  id?: string;
}

/**
 * Responsible for rendering notification container
 */
export const NotificationContainer: React.FC<INotificationProp> = (props: INotificationProp) => {

  const notificationData = useSelector((state: IRootState) => state.notificationState);
  const customId = (props.id !== undefined) ? props.id : "extract-notification-container";
  return (
    <div
      className="ebt-notification__container"
      data-testid="extract-notification-container"
      id={customId}
    >
      {
        notificationData.notificationItems.length > Numbers.Zero ?
          notificationData.notificationItems.map((item: INotification, index: number) => (
            <Notification
              key={item.id + String(index)}
              notificationData={item} />
          ))
          :
          null
      }
    </div>
  );
};
